<template>
	<div class="bd-header">
		<div class="title">{{ getTitle }}</div>
		<div class="time">
			<img class="time-icon" src="../assets/clock.png" />
			<span class="time-text">{{ year }}-{{ month }}-{{ day }} {{ week }}
				{{ hour }}:{{ minute }}:{{ second }}</span>
		</div>
		<template v-if="!logIsShowMarkder">
			<div class="device-list">
				<div class="device" v-for="item in deviceNumberToString" :key="item.id">
					<div class="device-name">{{ item.name }}</div>
					<ul class="device-data">
						<li class="device-data-item">{{ item.charArray[0] }}</li>
						<li class="device-data-item">{{ item.charArray[1] }}</li>
						<li class="device-data-item">{{ item.charArray[2] }}</li>
						<li class="device-data-item">{{ item.charArray[3] }}</li>
					</ul>
				</div>
			</div>
		</template>
		<template v-else>
			<div class="device-list">
				<div class="device" v-for="item in MockData" :key="item.id">
					<div class="device-name">{{ item.name }}</div>
					<ul class="device-data">
						<li class="device-data-item">{{ item.data[0] }}</li>
						<li class="device-data-item">{{ item.data[1] }}</li>
						<li class="device-data-item">{{ item.data[2] }}</li>
						<li class="device-data-item">{{ item.data[3] }}</li>
					</ul>
				</div>
			</div>
			<div class="device-list">
				<div class="device" v-for="item in MockData1" :key="item.id">
					<div class="device-name">{{ item.name }}</div>
					<ul class="device-data">
						<li class="device-data-item">{{ item.data[0] }}</li>
						<li class="device-data-item">{{ item.data[1] }}</li>
						<li class="device-data-item">{{ item.data[2] }}</li>
						<li class="device-data-item">{{ item.data[3] }}</li>
					</ul>
				</div>
			</div>
		</template>
	</div>
</template>

<script>
	import {
		mapGetters
	} from "vuex";

	export default {
		name: "bd-header",
		data() {
			return {
				MockData: [{
					name: '覆盖国家',
					data: [0, 0, 0, 5]
				}, {
					name: '覆盖省份',
					data: [0, 0, 3, 1]
				}, {
					name: '覆盖城市',
					data: [0, 1, 8, 3]
				}],
				MockData1: [{
					name: '智慧农场',
					data: [0, 9, 6, 0]
				}, {
					name: '设备数量',
					data: [8, 4, 8, 7]
				}, {
					name: '在线设备',
					data: [7, 4, 8, 8]
				}],
				year: null,
				month: null,
				day: null,
				week: null,
				hour: null,
				minute: null,
				second: null,
				count: 0
			};
		},
		mounted() {
			setInterval(() => {
				this.getNowDate();
				this.count += 1000;
				if (this.count === 300000) {
					this.$store.dispatch("weather/getWeather");
					this.count = 0;
				}
			}, 1000);
		},
		computed: {
			deviceNumberToString() {
				let result = [];
				this.$store.getters["map/getDeviceCount"].forEach(item => {
					let str = String(item.number);
					let charArray = ["0", "0", "0", "0"];
					for (let i = 0; i < str.length; i++) {
						charArray[charArray.length - 1 - i] = str[str.length - 1 - i];
					}
					result.push({
						...item,
						charArray: charArray
					});
				});
				return result;
			},
			getTitle() {
				let orginTitle = mapGetters('map', ['getBgTitle']).getBgTitle.call(this);
				const DafaultTitle = '智慧农业大数据平台'
				return orginTitle || DafaultTitle
			}
		},
		methods: {
			translateWeek(num) {
				let week = ["星期一", "星期二", "星期三", "星期四", "星期五", "星期六", "星期日"];
				return week[num - 1];
			},
			getNowDate() {
				let date = new Date();
				this.startTime = date.getTime();
				this.year = date.getFullYear();
				this.month = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
				this.day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
				this.week = this.translateWeek(date.getDay());
				this.hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
				this.minute = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
				this.second = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
			}
		},
		watch: {
			initialWidth(newValue) {
				this.style.width = newValue;
			}
		}
	};
</script>

<style scoped>
	.bd-header {
		position: absolute;
		top: 20px;
		left: 50%;
		transform: translateX(-50%);
		width: calc(100% - 53.23vw - 80px);
	}

	.title {
		font-size: 2vw;
		font-weight: 600;
		background-image: -webkit-linear-gradient(#00bdeb, #006f8b);
		background-clip: text;
		-webkit-text-fill-color: transparent;
		text-align: center;
		padding-top: 0.3vw;
		padding-bottom: 0.2vw;
	}

	.time {
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.time-icon {
		width: 0.8vw;
		height: 0.8vw;
	}

	.time-text {
		font-size: 0.8vw;
		padding-left: 0.3vw;
	}

	.device-list {
		display: flex;
		justify-content: space-around;
		padding-top: 0.5vw;
	}

	.device-name {
		font-size: 0.8vw;
		text-align: center;
	}

	.device-data {
		display: flex;
		list-style: none;
	}

	.device-data-item {
		color: rgba(0, 0, 33, 1);
		background-image: linear-gradient(#00bdeb, #006f8b);
		font-size: 1vw;
		font-weight: 600;
		padding: 0.05vw 0.3vw;
		margin: 0.1vw 0.1vw;
		border-radius: 0.15vw;
	}
</style>
